var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-carousel-slide',{attrs:{"img-src":_vm.banner.image_url,"img-width":"1024","img-max-height":"480"}})}
var staticRenderFns = []

export { render, staticRenderFns }